import React, { useEffect, useMemo, useState } from "react";
import { Avatar } from "antd";
import { connect } from "react-redux";
import { signOut } from "redux/actions/Auth";
import { getStaffPictureFromCache } from "utils/offlineCache";
import { APP_AVATAR_PLACEHOLDER_DATA_URL } from "assets/appLogo";
import { isOnline } from "utils/networkConnection";

export const NavProfile = ({ auth, logout }) => {
  const staffId = useMemo(() => auth?.data?._id || null, [auth?.data?._id]);
  const [cachedSrc, setCachedSrc] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const loadCachedAvatar = async () => {
      try {
        if (!staffId) {
          setCachedSrc(null);
          return;
        }

        const cachedResponse = await getStaffPictureFromCache(staffId);
        if (isCancelled) return;

        if (cachedResponse.status === true && cachedResponse.data) {
          setCachedSrc(cachedResponse.data);
          return;
        }

        setCachedSrc(null);
      } catch (error) {
        if (!isCancelled) {
          setCachedSrc(null);
        }
      }
    };

    loadCachedAvatar();

    return () => {
      isCancelled = true;
    };
  }, [staffId]);

  useEffect(() => {
    const handler = () => {
      // Re-read IndexedDB cache after a sync run stores new pictures.
      // This keeps the avatar up-to-date without requiring a full page refresh.
      if (!staffId) {
        return;
      }
      getStaffPictureFromCache(staffId).then((cachedResponse) => {
        if (cachedResponse.status === true && cachedResponse.data) {
          setCachedSrc(cachedResponse.data);
        }
      });
    };

    window.addEventListener("md-cache:staff-pictures-updated", handler);
    return () => {
      window.removeEventListener("md-cache:staff-pictures-updated", handler);
    };
  }, [staffId]);

  const pictureSrc = useMemo(() => {
    const raw = auth?.data?.picture ? String(auth.data.picture).trim() : "";
    if (raw.startsWith("data:image/")) {
      return raw;
    }
    if (!isOnline() && cachedSrc) {
      return cachedSrc;
    }
    if (isOnline() && raw) {
      return raw;
    }
    return APP_AVATAR_PLACEHOLDER_DATA_URL;
  }, [auth?.data?.picture, cachedSrc]);

  // const createMockAction = async () => {
  //   for (let i = 0; i < 12; i++) {
  //     createMockActionAction();
  //   }
  // };
  // const createMockActionAction = async () => {
  //   console.log("Creating mock action...");
  //   const method = ["POST", "PUT"][Math.floor(Math.random() * 2)];
  //   const data = {
  //     name: `Mock Action ${Math.floor(Math.random() * 1000)}`,
  //     timestamp: new Date().toISOString(),
  //   };
  //   await saveActionToStore({
  //     method: method,
  //     url: "/mock-endpoint",
  //     data: data,
  //     id: uniqid(`${method.toLowerCase()}-`),
  //   });
  // };

  return (
    <div className="nav-profile-header">
      <div>
        <Avatar size={45} src={pictureSrc} />
        {/* <div className="pl-3">
            <h4 className="mb-0">{auth?.data?.name}</h4>
            <h5 por SalesPark className="mb-0">
              {auth?.data?.role}
            </h5>
          </div> */}
      </div>
    </div>
  );
};

export default connect(null, { signOut })(NavProfile);
